import React from 'react';
import { technologies } from '../../../data/site';
import Marquee from '../../fx/Marquee';

const half = Math.ceil(technologies.length / 2);
const rows = [technologies.slice(0, half), technologies.slice(half)];

const Item = ({ children }) => (
  <span className="flex items-center gap-[var(--gap)] whitespace-nowrap">
    <span className="text-[clamp(1.5rem,3.2vw,2.75rem)] font-medium tracking-[-0.035em] text-foreground/80 [font-stretch:112%]">{children}</span>
    <svg width="10" height="10" viewBox="0 0 10 10" className="text-brand" aria-hidden="true">
      <circle cx="5" cy="5" r="3.5" fill="none" stroke="currentColor" />
    </svg>
  </span>
);

// The technologies we work with, as two counter-scrolling rails
const StackMarquee = () => (
  <section aria-label="Technologies we work with" className="relative border-y border-border py-8 md:py-10">
    <p className="label container-site mb-6">Platforms, languages &amp; models we build with</p>
    <div className="mask-fade-x space-y-3">
      {rows.map((row, i) => (
        <Marquee key={i} reverse={i === 1} pauseOnHover className="[--duration:70s] [--gap:2.25rem]">
          {row.map(tech => <Item key={tech}>{tech}</Item>)}
        </Marquee>
      ))}
    </div>
  </section>
);

export default StackMarquee;
